export const GET_INSURANCE_PICKER_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    insurancePickerBlock(id: "${id}", preview: ${preview}) {
      heading
      text
      helpLink {
        slug
        content {
          __typename
        }
      }
      helpLinkText
      sectorHeading
      roleHeading
      insurancesHeading
      linksCollection {
        items {
          sys {
            id
          }
          audienceCollection {
            items {
              audianceId
            }
          }
          linkText
          linkDescription
          url
          globalLinkItem
          reference {
            ... on Page {
              content {
                __typename
              }
              slug
            }
            ... on FileBlock {
              imageVaultFile
            }
          }
        }
      }
    }
  }
`;
